/**
 * Requerimiento info card for InspeccionDialog
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Building } from 'lucide-react';

const RequerimientoInfo = ({ requerimiento }) => {
  if (!requerimiento) return null;

  const getEstadoBadge = (estado) => {
    const estados = {
      'solicitado': 'bg-blue-100 text-blue-700',
      'inspeccion_pendiente': 'bg-yellow-100 text-yellow-700',
      'inspeccion_programada': 'bg-orange-100 text-orange-700',
      'atencion_pendiente': 'bg-purple-100 text-purple-700',
      'atencion_proceso': 'bg-indigo-100 text-indigo-700',
      'terminado': 'bg-green-100 text-green-700',
      'cerrado': 'bg-gray-100 text-gray-700'
    };
    return estados[estado] || 'bg-gray-100 text-gray-700';
  };

  return (
    <Card className="border-[#E8E8E7]">
      <CardHeader className="pb-3">
        <CardTitle className="text-base sm:text-lg flex items-center gap-2">
          <Building size={18} className="text-[#9d8272]" />
          Información del Requerimiento
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        <div>
          <p className="text-xs text-[#888888]">Proyecto</p>
          <p className="font-medium text-sm">{requerimiento.proyecto_nombre}</p>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Unidad (Depto)</p>
          <p className="font-medium text-sm">{requerimiento.departamento}</p>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Estado</p>
          <Badge className={`${getEstadoBadge(requerimiento.estado)} text-xs`}>
            {requerimiento.estado?.replace(/_/g, ' ')}
          </Badge>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Fecha Creación</p>
          <p className="font-medium text-sm">
            {new Date(requerimiento.fecha_solicitud).toLocaleDateString('es-PE')}
          </p>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Titular</p>
          <p className="font-medium text-sm">{requerimiento.cliente_nombre}</p>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Tel. Titular</p>
          <p className="font-medium text-sm">{requerimiento.cliente_telefono}</p>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Solicitante</p>
          <p className="font-medium text-sm">
            {requerimiento.solicitante_nombre || requerimiento.cliente_nombre}
          </p>
        </div>
        <div>
          <p className="text-xs text-[#888888]">Tel. Solicitante</p>
          <p className="font-medium text-sm">
            {requerimiento.solicitante_telefono || requerimiento.cliente_telefono}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default RequerimientoInfo;
